import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import '@babel/polyfill'
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';
import VueClipboard from 'vue-clipboard2'
import VueCoreVideoPlayer from 'vue-core-video-player'


Vue.config.productionTip = false
Vue.config.devtools = false



Vue.use(VueCoreVideoPlayer)

import Default from "./layouts/Default.vue";
import Blank from "./layouts/Blank.vue";

import axios from "./plugins/axios";

Vue.component("default-layout", Default);
Vue.component("blank-layout", Blank);

import "@fortawesome/fontawesome-free/css/all.css";
//axios
Vue.use(axios);

//notifications toasts
Vue.use(VueToast);

//VueClipboard.config.autoSetContainer = true
Vue.use(VueClipboard)

import moment from 'moment'
Vue.prototype.moment = moment;

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
